"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _RelatedContentCard = require("../RelatedContentCard/RelatedContentCard");
var _excluded = ["anchorId", "heading", "stackCards", "cards", "rightRail"];
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _heading, _item;
  return {
    heading: (_heading = {
      display: 'block',
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(22.5),
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'uppercase',
      margin: theme.spacing(6, 0, 0.5, 0)
    }, (0, _defineProperty2.default)(_heading, theme.breakpoints.up('md'), {
      lineHeight: theme.typography.pxToRem(24),
      margin: theme.spacing(6, 0, 4, 0)
    }), (0, _defineProperty2.default)(_heading, '.aem-Grid--default--3 &, .aem-Grid--default--4 &', {
      fontSize: theme.typography.pxToRem(18),
      textTransform: 'initial',
      margin: theme.spacing(6, 0, 4)
    }), _heading),
    gridInjectedText: (0, _defineProperty2.default)({
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(17)
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(16)
    }),
    gridInjectedLink: (0, _defineProperty2.default)({
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(14)
    }, theme.breakpoints.up('md'), {
      marginTop: theme.spacing(-0.5),
      marginBottom: theme.spacing(2),
      fontSize: theme.typography.pxToRem(16)
    }),
    container: {
      width: 'auto',
      margin: theme.spacing(0, -4)
    },
    item: (_item = {
      padding: theme.spacing(2, 4, 4, 4)
    }, (0, _defineProperty2.default)(_item, theme.breakpoints.up('md'), {
      padding: theme.spacing(3, 6, 3, 4)
    }), (0, _defineProperty2.default)(_item, '.aem-Grid--default--3 &, .aem-Grid--default--4 &', (0, _defineProperty2.default)({
      padding: theme.spacing(0, 4, 4, 4)
    }, theme.breakpoints.up('md'), {
      padding: theme.spacing(0, 6, 4, 4)
    })), (0, _defineProperty2.default)(_item, '.aem-Grid--default--3 &:last-child, .aem-Grid--default--4 &:last-child', {
      paddingBottom: 0
    }), _item),
    nonStackedItems: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      marginBottom: theme.spacing(10)
    })
  };
});
var RelatedContentGrid = function RelatedContentGrid(_ref) {
  var anchorId = _ref.anchorId,
    heading = _ref.heading,
    stackCards = _ref.stackCards,
    cards = _ref.cards,
    rightRail = _ref.rightRail,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles(stackCards);
  return __jsx("div", {
    id: anchorId,
    className: "aem-ms-cmp aem-ms-related-content-grid"
  }, heading && __jsx(_core.Typography, {
    className: classes.heading,
    component: "strong",
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), __jsx(_core.Grid, {
    container: true,
    className: classes.container
  }, cards && cards.map(function (linkProps, index) {
    return __jsx(_core.Grid, {
      item: true,
      className: (0, _clsx2.default)(classes.item, (0, _defineProperty2.default)({}, classes.nonStackedItems, !stackCards)),
      xs: 12,
      md: stackCards ? 12 : 3,
      key: "rc-grid-".concat(index)
    }, __jsx(_RelatedContentCard.RelatedContentCard, (0, _extends2.default)({}, linkProps, {
      maxTitleLines: 2,
      maxTextLines: 2,
      linkClassName: classes.gridInjectedLink,
      textClassName: classes.gridInjectedText
    })));
  })));
};
var RelatedContentGridEditConfig = {
  emptyLabel: 'Related Content Grid',
  isEmpty: function isEmpty(props) {
    if (props.heading || props.cards && props.cards.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/relatedcontentgrid')(RelatedContentGrid, RelatedContentGridEditConfig);
exports.default = _default;